import { type ShallowRef, shallowRef } from 'vue';
import exposeToGlobalScope from '@/shared/utils/expose-to-global-scope';
import {
  type AttractAssignment,
  type AttractSessionAttribution,
  isSameAssignment,
  sessionAttributionFor,
} from './experiment';

interface AttractLoopState {
  readonly current: ShallowRef<AttractAssignment | null>;
  apply: (next: AttractAssignment | null) => AttractAssignment | null;
  sessionAttribution: () => AttractSessionAttribution;
}

const current: ShallowRef<AttractAssignment | null> = shallowRef(null);

// Holds the loop currently on screen. Home is the only writer and only writes
// while idle, so sessions and prints are attributed to what the visitor saw.
export const attractLoop: AttractLoopState = {
  current,

  apply(next: AttractAssignment | null): AttractAssignment | null {
    const previous = current.value;
    if (!isSameAssignment(previous, next)) {
      current.value = next;
    }
    return previous;
  },

  sessionAttribution(): AttractSessionAttribution {
    return sessionAttributionFor(current.value);
  },
};

exposeToGlobalScope(attractLoop, 'AttractLoop');
